import { isTransactionReplacedError } from "@silo/utils";
import { ContractTransaction } from "ethers";
import { useCallback } from "react";
import { useSiloWeb3 } from "../SiloWeb3Provider";
import { Transaction } from "../types";
import { useTransactionMachine } from "./TransactionContext";
import { now } from "./utilities";

export const useAddTransaction = () => {
  const { send } = useTransactionMachine();
  const { chainId } = useSiloWeb3();

  const addTransaction = useCallback(
    (tx: ContractTransaction, message: string) => {
      if (!chainId) return;

      const transaction: Transaction = {
        tx,
        message,
        status: "pending",
        chainId: chainId,
        timeAdded: now(),
      };

      send({ type: "ADD", transaction });

      async function wait() {
        try {
          const { status } = await tx.wait();

          if (status === 0) {
            throw new Error(`Transaction ${tx.hash} reverted`);
          }

          send({ type: "SUCCESS", hash: tx.hash });
        } catch (error) {
          if (isTransactionReplacedError(error)) {
            send({ type: "REMOVE", hash: tx.hash });
            addTransaction(error.replacement as ContractTransaction, message);
          } else {
            send({ type: "ERROR", hash: tx.hash });
          }
        }
      }

      wait();
    },
    [chainId, send]
  );

  return addTransaction;
};
